import { React } from '@biletiniz/ui-core';
import { Layout } from '@biletiniz/ui-layout';
import { useRouter } from '@biletiniz/web-app-hooks';
import { NextSeo } from '@biletiniz/seo';
import { BusReservationQueryContainer } from '@biletiniz/web-app-containers';
import { LayoutHeader } from '@biletiniz/web-app-components';
import Head from 'next/head';

const BusReservationQuery = () => {
  const { busPnrQueryForm, router } = useRouter();
  return (
    <>
      <NextSeo
        title="Otobüs Bileti Sorgulama - Biletiniz.com | Otobüs Bilgileri ve Seyahat Detayları"
        description="Biletiniz.com'dan yaptığınız otobüs bileti sorgulayın. Biletiniz detaylarına ulaşın ve otobüs seyahat bilgilerinizi kontrol edin."
        canonical={`https://biletiniz.com${
          router.locale !== 'tr' ? '/en' : ''
        }/rezervasyon-sorgulama/otobus`}
      />
      <Head>
        <meta
          name="keywords"
          content="Otobüs Bileti Sorgulama, Otobüs Seyahat Detayları, Biletiniz.com Otobüs Bileti, Bilet Bilgileri, Otobüs Seyahati Kontrol, Otobüs Takip"
        />
      </Head>
      <Layout>
        <LayoutHeader activeItem="buses" router={router} />
        <Layout.Container py={5}>
          <BusReservationQueryContainer initialValues={busPnrQueryForm} />
        </Layout.Container>
        <Layout.Footer activeItem="buses" />
      </Layout>
    </>
  );
};

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  return {
    props: { lng: context.locale, lngDict },
  };
}

export default BusReservationQuery;
